module.exports = __webpack_public_path__ + "img/tenderapprove.b2d3daa8.png";